(() => {
  const attach = (root) => {
    if (!root || root.dataset.suruttoLabelReady) return;
    root.dataset.suruttoLabelReady = 'true';
    const label = root.dataset.suruttoNotificationLabel;
    if (!label) return;
    const watched = new Set();
    const update = () => {
      const surfaces = [root];
      for (const surface of surfaces) {
        surface.querySelectorAll('.channelize-shadowdom-wrapper').forEach((host) => {
          if (host.shadowRoot) surfaces.push(host.shadowRoot);
        });
        if (!watched.has(surface)) {
          watched.add(surface);
          new MutationObserver(update).observe(surface, { childList: true, subtree: true, characterData: true });
        }
        surface.querySelectorAll('.ch-live-broadcast__notifyme__container__popup__container__title').forEach((node) => {
          if (node.dataset.suruttoCalendarCopy) return;
          node.dataset.suruttoCalendarCopy = 'true';
          node.setAttribute('translate', 'no');
          node.textContent = 'LIVEの予定をカレンダーに追加できます。';
          const note = document.createElement('small');
          note.setAttribute('translate', 'no');
          note.textContent = '通知を受け取るには、ご利用のカレンダーで通知を設定してください。';
          note.style.cssText = 'display:block;font-size:12px;font-weight:400;line-height:1.8;margin-top:12px;';
          node.appendChild(note);
        });
        surface.querySelectorAll('.ch-live-broadcast__outline-button > div').forEach((node) => {
        const original = node.textContent.trim();
        if (node.childElementCount === 0 && ['私に通知する', 'Notify me', 'Notify Me', 'notify me'].includes(original)) {
          node.setAttribute('translate', 'no');
          node.textContent = label;
        }
        });
      }
    };
    update();
    const discovery = setInterval(() => {
      update();
      if (watched.size > 1) clearInterval(discovery);
    }, 500);
    setTimeout(() => clearInterval(discovery), 15000);
  };
  attach(document.getElementById('SuruttoLivePlayer'));
  document.addEventListener('shopify:section:load', (event) => {
    attach(event.target.querySelector('#SuruttoLivePlayer'));
  });
})();
